import { Button, Select } from '@trackman/web-shared-components';

import { AdminTourAveragesUnits } from 'types/admin/tourAverages';
import { Input } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { clubsDefaults } from 'stores/Admin/Editors/TourAveragesEditorStore';
import { observer } from 'mobx-react-lite';
import { unitNamesMapper } from 'utilities/unitNamesMapper';
import { useStores } from 'index';

export const TourAveragesTableToolbar = observer(() => {
  const ta = useStores().tourAverageEditorStore;
  const ps = useStores().parametersStore;

  return (
    <div className='admin-edit-section table-toolbar'>
      <div className='input-container year-input'>
        <Paragraph>
          <>Year of data collected:</>
        </Paragraph>
        <Input
          type='number'
          label='Year'
          value={ta.tourAveragesData.year ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => (ta.tourAveragesData.year = Number(e.currentTarget.value))}
        />
      </div>
      {ps.filteredPGAList.length ? (
        <>
          <div className='inputs-wrapper'>
            <div className='input-container'>
              <Select
                label='Parameter name'
                value={ta.newTourParameterData.parameterId ?? ''}
                onChange={(event) => {
                  ta.newTourParameterData = { ...ta.cleanTourParameterData };
                  const selectedParameter = ps.filteredPGAList.find((param) => param.id === event.target.value);
                  if (selectedParameter) ta.newTourParameterData = { ...ta.newTourParameterData, parameterId: selectedParameter.id };
                }}
                selectOptions={ps.filteredPGAList.map((parameter) => {
                  return {
                    label: `${parameter.title} (${parameter.primaryCategory})`,
                    value: parameter.id,
                  };
                })}
              />
            </div>
            <div className='input-container'>
              <Select
                label='Parameter unit'
                disabled={ta.newTourParameterData.parameterId === ''}
                value={ta.newTourParameterData?.unit ?? ''}
                onChange={(event) => {
                  if (ta.newTourParameterData.parameterId !== '')
                    ta.newTourParameterData = { ...ta.newTourParameterData, unit: event.target.value as string };
                }}
                selectOptions={Object.values(AdminTourAveragesUnits)
                  .filter((unit) => unit !== '')
                  .map((unit) => {
                    return {
                      label: unitNamesMapper(unit),
                      value: unit,
                    };
                  })}
              />
            </div>
          </div>
          <Button
            className='styled-button primary'
            disabled={ta.newTourParameterData.parameterId === ''}
            onClick={() => {
              ta.tourAveragesData.pga.push({ ...ta.newTourParameterData, clubs: clubsDefaults });
              ta.tourAveragesData.lpga.push({ ...ta.newTourParameterData, clubs: clubsDefaults });
              ps.filteredPGAList = ps.filteredPGAList.filter((parameter) => parameter.id !== ta.newTourParameterData.parameterId);
              ta.newTourParameterData = { ...ta.cleanTourParameterData };
            }}
          >
            Add new PGA parameter
          </Button>
        </>
      ) : (
        <Paragraph>
          <>All parameters are added</>
        </Paragraph>
      )}
    </div>
  );
});

export default TourAveragesTableToolbar;
